import { Section } from "anketa-core/group";
import { Translation } from "anketa-core/i18n";
import { setupComment } from "./comment";
import { QuestionsRightsTypes } from "..";

export const commentSection = (
  questionsRights: (q: QuestionsRightsTypes) => void
): Section => {
  const section = new Section("comment", [
    new Translation("en", "Questions and Comments"),
    new Translation("de", "Fragen und Kommentare"),
  ]);
  questionsRights(section);

  section.help = [
    new Translation(
      "en",
      `Here you can ask questions, leave comments and exchange ideas with others.`
    ),
    new Translation(
      "de",
      `Hier können Sie Fragen stellen, Kommentare hinterlassen und sich mit anderen austauschen.`
    ),
  ];

  setupComment(section, 0, questionsRights);
  return section;
};
